// Typing simulation utility
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const typeText = async (text, callback, options = {}) => {
  const {
    minSpeed = 30,
    maxSpeed = 80,
    mistakeChance = 0.05
  } = options;

  for (let i = 0; i < text.length; i++) {
    // Random typing speed
    const speed = Math.random() * (maxSpeed - minSpeed) + minSpeed;

    // Simulate typing mistake occasionally
    if (Math.random() < mistakeChance && i < text.length - 1) {
      const wrongChar = String.fromCharCode(text.charCodeAt(i) + 1);
      callback(text.substring(0, i) + wrongChar);
      await sleep(speed);
      await sleep(200); // Pause before correction
      callback(text.substring(0, i)); // Backspace
      await sleep(100);
    }

    callback(text.substring(0, i + 1));
    await sleep(speed);
  }
};

export const animateProgressBar = async (callback, duration = 2000, steps = 100) => {
  const stepDuration = duration / steps;

  for (let i = 0; i <= steps; i++) {
    callback(i);
    await sleep(stepDuration);
  }
};

export const countUp = async (from, to, callback, duration = 2000) => {
  const steps = 50;
  const stepValue = (to - from) / steps;
  const stepDuration = duration / steps;

  for (let i = 0; i <= steps; i++) {
    const currentValue = Math.floor(from + (stepValue * i));
    callback(currentValue);
    await sleep(stepDuration);
  }

  callback(to); // Ensure final value is exact
};
